"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Notification = void 0;
const common_1 = require("../../common");
const enums_1 = require("../enums");
const sales_order_header_model_1 = require("./sales-order-header.model");
class Notification extends common_1.MongoDocument {
}
exports.Notification = Notification;
//# sourceMappingURL=notification.model.js.map